import { render, staticRenderFns } from "./resetPwBtn.vue?vue&type=template&id=3e1ace6c&"
import script from "./resetPwBtn.vue?vue&type=script&lang=js&"
export * from "./resetPwBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports